import { c as _c } from "react/compiler-runtime";
import { BottomSheet } from "@opensea/ui-kit";
import { CurrencySelectContent } from "./CurrencySelectContent";
export const CurrencySelectSheet = t0 => {
  const $ = _c(15);
  let container;
  let onOpenChange;
  let open;
  let rest;
  if ($[0] !== t0) {
    ({
      open,
      onOpenChange,
      container,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = container;
    $[2] = onOpenChange;
    $[3] = open;
    $[4] = rest;
  } else {
    container = $[1];
    onOpenChange = $[2];
    open = $[3];
    rest = $[4];
  }
  let t1;
  if ($[5] !== onOpenChange) {
    t1 = () => onOpenChange?.(false);
    $[5] = onOpenChange;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== rest || $[8] !== t1) {
    t2 = <CurrencySelectContent {...rest} onClose={t1} />;
    $[7] = rest;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== container || $[11] !== onOpenChange || $[12] !== open || $[13] !== t2) {
    t3 = <BottomSheet className="h-full overflow-hidden" container={container} content={t2} onOpenChange={onOpenChange} open={open} withCloseIcon={false} />;
    $[10] = container;
    $[11] = onOpenChange;
    $[12] = open;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};